import { render, staticRenderFns } from "./block-advertisement.vue?vue&type=template&id=d3800726&scoped=true&"
import script from "./block-advertisement.vue?vue&type=script&lang=js&"
export * from "./block-advertisement.vue?vue&type=script&lang=js&"
import style0 from "./block-advertisement.vue?vue&type=style&index=0&id=d3800726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3800726",
  null
  
)

export default component.exports